import { useI18n } from 'hooks/useI18n';
import { useToasts } from 'hooks/useToasts/useToasts';
import { useCallback, useEffect, useState } from 'react';
import { ServiceChangePassword } from 'services/service-change-password';
import { UseChangePasswordConfirmModal } from './ChangePasswordConfirmModal.types';

export const useChangePasswordConfirmModal = (
  manfrediteEmail: string,
  isOpen: boolean
): UseChangePasswordConfirmModal => {
  const { t } = useI18n('portal-settings');
  const { addErrorToast } = useToasts();

  const [isPasswordChangeRequestSent, setIsPasswordChangeRequestSent] =
    useState(false);

  const sendChangePasswordRequest = useCallback(async () => {
    try {
      await ServiceChangePassword.changePassword(manfrediteEmail);

      setIsPasswordChangeRequestSent(true);
    } catch (ex) {
      console.error(
        `Could not request Manfredite password change. Exception: ${ex}`
      );

      setIsPasswordChangeRequestSent(false);

      addErrorToast(
        t(
          'portal-settings.account.form.password.confirm.messages.error.change-pass-request'
        )
      );
    }
  }, [manfrediteEmail, addErrorToast, t]);

  useEffect(() => {
    setIsPasswordChangeRequestSent(!isOpen);
  }, [isOpen]);

  return {
    isPasswordChangeRequestSent,
    sendChangePasswordRequest
  };
};
